import { defineStore } from 'pinia'
import { useLegalDocumentTemplateStore } from './legalDocumentTemplate'
import { computed, ref } from 'vue'

export const useLegalDocumentStore = defineStore('legalDocument', () => {
  const legalDocumentTemplateStore = useLegalDocumentTemplateStore()

  const sections = ref<string[]>([])
  const initialSortOrder: { [key: string]: number } = {}

  const section = (code: string) => legalDocumentTemplateStore.find(code)

  const additionalSections = computed(() => {
    const legalDocumentTemplateStore = useLegalDocumentTemplateStore()

    const allSections = legalDocumentTemplateStore.sections

    if (!allSections) {
      return []
    }

    return Object.values(allSections).filter(section => !sections.value.includes(section.code))
  })

  const initialSortSort = (orignialOrder: string[]) => {
    if (!Object.keys(initialSortOrder).length) {
      orignialOrder.forEach((sectionCode, index) => (initialSortOrder[sectionCode] = index))
    }
  }
  const sortSections = () => {
    sections.value = sections.value.sort((a, b) => {
      return initialSortOrder[a] - initialSortOrder[b]
    })
  }

  const remove = (code: string) => {
    sections.value = sections.value.filter(section => section !== code)
    sortSections()
  }

  const insert = (code: string) => {
    if (sections.value.find(section => section === code) !== undefined) {
      return
    }

    sections.value.push(code)
    sortSections()
  }

  return {
    // state
    sections,

    // actions
    remove,
    insert,
    section,

    // getters
    additionalSections,

    // inplace methods
    initialSortSort,
  }
})
